import React from 'react';
import { Undo2 } from 'lucide-react';
import { AppIcon } from './LucideIcon';
import { fieldChangeText, type FieldChange } from './agentFieldChanges';

/**
 * A field the agent changed: the input it wraps, a left bar in the kind's
 * colour, a restore button at the right end of the input row, and, when there
 * was an old value, that value under the input. Without a change it renders
 * the input alone.
 */
export default function ChangedField({
  change,
  onRestore,
  children,
}: {
  change?: FieldChange;
  onRestore: () => void;
  children: React.ReactNode;
}) {
  if (!change) return <>{children}</>;
  return (
    <div className={`pnid-changed-field pnid-changed-field--${change.kind}`} data-change-kind={change.kind}>
      <div className="pnid-changed-field__body">{children}</div>
      <button
        type="button"
        className="pnid-changed-field__restore"
        onClick={onRestore}
        title="Restore previous value"
        aria-label="Restore previous value"
      >
        <AppIcon icon={Undo2} size={16} />
      </button>
      {change.kind !== 'added' && (
        <div className="pnid-changed-field__note">was {fieldChangeText(change.previous)}</div>
      )}
    </div>
  );
}
